function prepareLibrary(root = document) {
  root.querySelectorAll('[data-gallery]').forEach((gallery) => {
    if (gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const figures = [...gallery.querySelectorAll('[data-gallery-item]')];
    const links = [...gallery.querySelectorAll('[data-gallery-target]')];
    if (figures.length < 2) return;
    const select = (index) => {
      figures.forEach((figure) => {
        const active = figure.dataset.galleryItem === index;
        figure.hidden = !active;
        figure.toggleAttribute('data-active', active);
      });
      links.forEach((link) => {
        if (link.dataset.galleryTarget === index) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    };
    links.forEach((link) => link.addEventListener('click', (event) => {
      event.preventDefault();
      select(link.dataset.galleryTarget);
    }));
    select(figures[0].dataset.galleryItem);
  });
  root.querySelectorAll('[data-product-section]').forEach((section) => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const select = section.querySelector('[data-variant-select]');
    if (!select) return;
    const update = () => {
      const option = select.selectedOptions[0];
      const available = option.dataset.available === 'true';
      section.querySelectorAll('[data-variant-price]').forEach((price) => { price.textContent = option.dataset.price; });
      section.querySelectorAll('[data-add-button]').forEach((button) => {
        button.disabled = !available;
        button.textContent = available ? button.dataset.labelReady : button.dataset.labelUnavailable;
      });
    };
    select.addEventListener('change', update);
    update();
  });
}
prepareLibrary();
document.addEventListener('shopify:section:load', (event) => prepareLibrary(event.target));
document.addEventListener('click', (event) => {
  document.querySelectorAll('.mobile-nav[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.open = false;
    else if (event.target.closest('a')) menu.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') document.querySelectorAll('.mobile-nav[open]').forEach((menu) => { menu.open = false; });
});

